export enum CancellationPolicyPeriod {
  hours = 'hours',
  days = 'days',
}
